var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyIlustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 274 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.238 246.279H18.0093C18.0093 246.279 10.4132 233.479 5.14548 207.752C-0.122267 182.024 24.9815 191.415 31.4006 169.237C37.8197 147.06 9.81506 151.736 12.1498 121.39C14.4846 91.0445 52.9926 90.4656 71.6644 94.5499C90.3363 98.6342 88.0015 84.6319 109.613 61.2904C131.224 37.949 163.879 40.2838 180.216 58.3768C196.553 76.4698 191.298 95.1352 211.732 95.1352C232.167 95.1352 250.845 99.2388 263.066 138.332C275.286 177.425 252.923 195.293 253.328 212.942C253.662 224.147 254.971 235.301 257.238 246.279Z",
    fill: "url(#paint0_linear_930_54521)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M257.238 246.279H18.0093C18.0093 246.279 10.4132 233.479 5.14548 207.752C-0.122267 182.024 24.9815 191.415 31.4006 169.237C37.8197 147.06 9.81506 151.736 12.1498 121.39C14.4846 91.0445 52.9926 90.4656 71.6644 94.5499C90.3363 98.6342 88.0015 84.6319 109.613 61.2904C131.224 37.949 163.879 40.2838 180.216 58.3768C196.553 76.4698 191.298 95.1352 211.732 95.1352C232.167 95.1352 250.845 99.2388 263.066 138.332C275.286 177.425 252.923 195.293 253.328 212.942C253.662 224.147 254.971 235.301 257.238 246.279Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.752 246.28C108.893 237.359 83.8789 199.848 76.5593 198.845C69.4263 197.867 44.0781 235.796 37.2217 246.28H114.752Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.828 27.0977V113.601",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.106 29.4199V113.601",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.375 75.4863V157.024",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.306 29.4199V157.023",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.237 29.4199V115.923",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.881 38.6953H192.572",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.881 57.9199H197.19",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.891 75.4863H202.844",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.894 95.0449H202.844",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.488 116.252H199.197",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M161.744 136.801H194.887",
    stroke: "#1D1D1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4883 35.3125L86.188 44.4716",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8877 25.6504L101.959 31.7543",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.746 10.8965L122.309 22.088",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M185.497 154.714H166.201V108.835H140.023V27.5801C128.99 27.689 118.171 30.6341 108.606 36.1324C99.04 41.6306 91.0496 49.497 85.4024 58.9755C79.7553 68.454 76.6413 79.2257 76.3598 90.2554C76.0783 101.285 78.6389 112.202 83.7952 121.956C85.892 126.838 90.8189 138.794 95.7522 154.257C100.312 168.529 102.692 182.879 102.692 185.046C102.692 185.259 102.692 185.477 102.692 185.69C102.67 186.335 102.777 186.978 103.009 187.581C103.24 188.183 103.59 188.733 104.039 189.198C104.487 189.662 105.024 190.032 105.618 190.285C106.212 190.537 106.851 190.667 107.497 190.668H173.906C174.552 190.667 175.19 190.536 175.784 190.283C176.378 190.03 176.915 189.66 177.363 189.196C177.811 188.732 178.161 188.182 178.393 187.58C178.624 186.977 178.733 186.335 178.711 185.69C178.711 185.458 178.711 185.239 178.711 185.046C178.698 182.905 181.033 168.832 185.497 154.714Z",
    fill: "url(#paint1_linear_930_54521)",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M118.226 37.95C120.087 37.1108 121.996 36.3827 123.944 35.7695",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8071 54.2472C96.8071 54.2472 102.049 45.8857 113.569 40.2578",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1836 146.816C100.57 154.612 103.728 165.411 104.821 171.444C106.674 181.62 105.465 186.881 109.452 187.788",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2632 137.516C95.2632 137.516 95.9064 139.606 96.9419 142.809",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M136.627 190.046V128.556C136.627 128.556 139.2 112.477 130.838 112.477C122.477 112.477 123.12 120.838 132.768 129.843C142.416 138.847 157.209 130.486 159.139 123.411C161.068 116.336 155.923 113.12 152.707 118.908C149.491 124.697 152.707 190.303 152.707 190.303",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.585 190.295H106.178V206.4H175.585V190.295Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M175.585 210.234H106.178V226.34H175.585V210.234Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M175.585 206.4H106.178V210.234H175.585V206.4Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M175.585 230.174H106.178V246.279H175.585V230.174Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M168.324 204.246H173.482",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M108.905 204.246H165.841",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M154.945 224.5H171.572",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.209 224.5H153.035",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M113.671 224.5H116.534",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M175.585 226.34H106.178V230.173H175.585V226.34Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M138.975 233.705H115.215V246.074H138.975V233.705Z",
    fill: "#59D9C6",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M169.893 233.705H146.133V246.074H169.893V233.705Z",
    fill: "url(#paint2_linear_930_54521)",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M191.266 246.279C186.713 242.285 167.269 225.491 161.609 225.053C156.064 224.61 136.383 241.596 131.057 246.279H191.266Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M266.333 246.279H271.916",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7671 246.279H260.75",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08398 246.279H6.42553",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M255.097 209.57H238.406V232.983H245.32H255.097H262.017V221.276L255.097 209.57Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M262.018 232.982H254.37V238.302H262.018V232.982Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M225.999 232.719C225.999 232.719 234.36 228.216 231.466 205.705L220.853 199.916L202.522 197.021L186.121 197.665V206.991C186.121 206.991 195.447 215.031 196.412 217.604C197.017 219.364 197.342 221.209 197.376 223.071V232.075L225.999 232.719Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M231.466 205.705L225.999 232.719",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M220.853 199.916L214.743 232.719",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M202.522 197.021L198.02 221.463",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M186.764 205.705C186.764 205.705 197.377 210.207 201.558 213.102C205.738 215.996 205.095 222.106 205.095 222.106",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M238.554 233.15H188.688V237.331H238.554V233.15Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M248.511 222.429H258.924L253.335 212.781H248.511V222.429Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M246.903 212.781H242.4V222.429H246.903V212.781Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M219.309 232.982H188.951V240.231H219.309V232.982Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M248.069 246.162C251.54 245.534 253.846 242.212 253.219 238.741C252.592 235.27 249.27 232.964 245.798 233.591C242.327 234.218 240.022 237.541 240.649 241.012C241.276 244.483 244.598 246.789 248.069 246.162Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M246.922 243.622C248.979 243.622 250.646 241.955 250.646 239.898C250.646 237.841 248.979 236.174 246.922 236.174C244.865 236.174 243.198 237.841 243.198 239.898C243.198 241.955 244.865 243.622 246.922 243.622Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M198.844 246.174C202.318 245.559 204.635 242.245 204.02 238.771C203.405 235.298 200.091 232.981 196.617 233.596C193.144 234.21 190.827 237.525 191.442 240.998C192.057 244.471 195.371 246.789 198.844 246.174Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M197.718 243.622C199.774 243.622 201.442 241.955 201.442 239.898C201.442 237.841 199.774 236.174 197.718 236.174C195.661 236.174 193.994 237.841 193.994 239.898C193.994 241.955 195.661 243.622 197.718 243.622Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M217.458 244.575C220.056 242.189 220.228 238.149 217.842 235.551C215.457 232.953 211.416 232.781 208.818 235.166C206.22 237.552 206.048 241.593 208.434 244.191C210.819 246.789 214.86 246.961 217.458 244.575Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M213.135 243.622C215.191 243.622 216.859 241.955 216.859 239.898C216.859 237.841 215.191 236.174 213.135 236.174C211.078 236.174 209.411 237.841 209.411 239.898C209.411 241.955 211.078 243.622 213.135 243.622Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M211.045 221.785H194.965C193.81 221.785 192.875 222.721 192.875 223.876V230.629C192.875 231.784 193.81 232.719 194.965 232.719H211.045C212.199 232.719 213.135 231.784 213.135 230.629V223.876C213.135 222.721 212.199 221.785 211.045 221.785Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M184.834 232.72V200.914H191.266V232.72",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M184.879 205.127H191.196",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M184.879 210.092H191.196",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M184.879 215.057H191.196",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M184.879 220.029H191.196",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M184.879 224.994H191.196",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M184.879 229.961H191.196",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1893 246.902H44.6118V44.9395L56.1893 58.4015V246.902Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 204.452H56.0804L44.728 193.473H56.0804L44.728 204.452Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 193.196H56.0804L44.728 182.217H56.0804L44.728 193.196Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 181.94H56.0804L44.728 170.961H56.0804L44.728 181.94Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 170.684H56.0804L44.728 159.705H56.0804L44.728 170.684Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 159.429H56.0804L44.728 148.449H56.0804L44.728 159.429Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 148.173H56.0804L44.728 137.193H56.0804L44.728 148.173Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 136.917H56.0804L44.728 125.938H56.0804L44.728 136.917Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 125.661H56.0804L44.728 114.682H56.0804L44.728 125.661Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 114.405H56.0804L44.728 103.426H56.0804L44.728 114.405Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 103.149H56.0804L44.728 92.1699H56.0804L44.728 103.149Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 91.8934H56.0804L44.728 80.9141H56.0804L44.728 91.8934Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 80.6375H56.0804L44.728 69.6582H56.0804L44.728 80.6375Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M44.728 69.3816H56.0804L44.728 58.4023H56.0804L44.728 69.3816Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M109.941 69.6835L104.332 66.1523H64.3062L59.418 69.6835H109.941Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M110.867 69.3809H13.1021V71.9536H110.867V69.3809Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M104.332 66.1519L44.6118 44.9395L64.3064 66.1519",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6185 44.9395L13.1021 69.3808",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5572 74.8477H40.4375V90.2843H64.5572V74.8477Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5276 78.0645H45.4609V82.5668H59.5276V78.0645Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M110.867 71.9531V99.6876",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M114.534 109.162H107.388V117.26H114.534V109.162Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M107.388 109.162L110.964 99.1602L114.54 109.162",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M91.591 206.882L107.028 231.285L110.887 228.461L99.528 205.744C99.0175 204.723 98.2325 203.864 97.2611 203.264C96.2897 202.664 95.1704 202.347 94.0287 202.348C93.5046 202.357 92.9925 202.506 92.5451 202.779C92.0977 203.053 91.731 203.44 91.4828 203.902C91.2346 204.363 91.1138 204.883 91.1328 205.406C91.1518 205.93 91.31 206.44 91.591 206.882Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M109.529 225.285L93.6489 236.58C93.6489 236.58 95.0639 242.574 104.236 242.22C113.408 241.867 113.06 232.341 113.06 232.341L109.529 225.285Z",
    fill: "#1D1D1D",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4194 217.875L94.183 204.915C95.1316 204.488 96.1978 204.399 97.2042 204.662C98.2105 204.925 99.0964 205.525 99.7145 206.362C100.076 206.851 100.335 207.407 100.478 207.997C100.62 208.588 100.643 209.201 100.545 209.801C100.447 210.4 100.229 210.974 99.9052 211.488C99.5814 212.002 99.1579 212.446 98.6596 212.794L67.1882 234.823L65.4194 217.875Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1872 233.756H31.5425V238.342H61.1872V233.756Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7154 220.699H20.9556V231.286H46.7154V220.699Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3642 208.695H65.2328C65.7445 208.695 66.2353 208.899 66.5972 209.26C66.9591 209.622 67.1623 210.113 67.1623 210.625V231.271H41.4282V210.625C41.4282 210.371 41.4783 210.12 41.5757 209.885C41.6731 209.65 41.8158 209.437 41.9957 209.258C42.1755 209.079 42.389 208.937 42.6238 208.84C42.8587 208.744 43.1103 208.694 43.3642 208.695Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6918 246.278H62.8659C64.1982 246.278 65.4759 245.748 66.418 244.806C67.36 243.864 67.8893 242.587 67.8893 241.254C67.8893 239.922 67.3602 238.643 66.4183 237.7C65.4765 236.757 64.1988 236.226 62.8659 236.225H20.6918C19.3589 236.226 18.0812 236.757 17.1394 237.7C16.1975 238.643 15.6685 239.922 15.6685 241.254C15.6685 242.587 16.1977 243.864 17.1398 244.806C18.0818 245.748 19.3595 246.278 20.6918 246.278Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0464 246.278H69.2141C70.5469 246.278 71.8253 245.749 72.7684 244.807C73.7115 243.865 74.2421 242.587 74.2438 241.254C74.2438 239.92 73.7139 238.641 72.7706 237.698C71.8274 236.755 70.548 236.225 69.2141 236.225H27.0464C25.7124 236.225 24.433 236.755 23.4898 237.698C22.5465 238.641 22.0166 239.92 22.0166 241.254C22.0183 242.587 22.549 243.865 23.4921 244.807C24.4351 245.749 25.7135 246.278 27.0464 246.278Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1818 231.285H20.9556V234.816H67.1818V231.285Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4876 241.255C30.4876 241.884 30.3012 242.498 29.9521 243.021C29.6029 243.543 29.1067 243.951 28.5261 244.191C27.9455 244.431 27.3067 244.494 26.6903 244.372C26.074 244.249 25.5078 243.947 25.0634 243.502C24.6191 243.058 24.3165 242.492 24.1939 241.875C24.0713 241.259 24.1342 240.62 24.3747 240.04C24.6152 239.459 25.0224 238.963 25.5449 238.614C26.0674 238.264 26.6818 238.078 27.3102 238.078C28.1529 238.078 28.9611 238.413 29.5569 239.009C30.1528 239.605 30.4876 240.413 30.4876 241.255Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7809 244.433C37.5357 244.433 38.9583 243.01 38.9583 241.256C38.9583 239.501 37.5357 238.078 35.7809 238.078C34.0261 238.078 32.6035 239.501 32.6035 241.256C32.6035 243.01 34.0261 244.433 35.7809 244.433Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2452 244.433C46.0001 244.433 47.4226 243.01 47.4226 241.256C47.4226 239.501 46.0001 238.078 44.2452 238.078C42.4904 238.078 41.0679 239.501 41.0679 241.256C41.0679 243.01 42.4904 244.433 44.2452 244.433Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8938 241.255C55.8938 241.884 55.7075 242.498 55.3583 243.021C55.0092 243.543 54.513 243.951 53.9324 244.191C53.3518 244.431 52.7129 244.494 52.0966 244.372C51.4802 244.249 50.9141 243.947 50.4697 243.502C50.0253 243.058 49.7227 242.492 49.6001 241.875C49.4775 241.259 49.5404 240.62 49.7809 240.04C50.0214 239.459 50.4287 238.963 50.9512 238.614C51.4737 238.264 52.088 238.078 52.7164 238.078C53.5591 238.078 54.3673 238.413 54.9632 239.009C55.559 239.605 55.8938 240.413 55.8938 241.255Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3645 241.255C64.3645 241.884 64.1782 242.498 63.829 243.021C63.4799 243.543 62.9837 243.951 62.4031 244.191C61.8225 244.431 61.1836 244.494 60.5673 244.372C59.9509 244.249 59.3848 243.947 58.9404 243.502C58.496 243.058 58.1934 242.492 58.0708 241.875C57.9482 241.259 58.0111 240.62 58.2516 240.04C58.4921 239.459 58.8994 238.963 59.4219 238.614C59.9444 238.264 60.5587 238.078 61.1871 238.078C62.0298 238.078 62.838 238.413 63.4339 239.009C64.0298 239.605 64.3645 240.413 64.3645 241.255Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8289 241.256C72.8289 241.884 72.6423 242.499 72.2929 243.021C71.9435 243.544 71.4469 243.951 70.8659 244.192C70.285 244.432 69.6458 244.494 69.0292 244.371C68.4127 244.248 67.8466 243.945 67.4025 243.5C66.9584 243.055 66.6563 242.488 66.5344 241.871C66.4125 241.255 66.4764 240.616 66.7178 240.035C66.9593 239.455 67.3676 238.959 67.8909 238.61C68.4143 238.262 69.0292 238.077 69.6579 238.078C70.0749 238.078 70.4877 238.16 70.8729 238.32C71.258 238.48 71.6079 238.714 71.9024 239.009C72.1969 239.304 72.4304 239.655 72.5893 240.04C72.7483 240.426 72.8297 240.839 72.8289 241.256Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5341 208.697C97.5341 208.346 97.4302 208.004 97.2356 207.713C97.041 207.422 96.7643 207.195 96.4408 207.062C96.1172 206.928 95.7612 206.893 95.4179 206.962C95.0746 207.031 94.7595 207.2 94.5124 207.448C94.2653 207.696 94.0973 208.012 94.0298 208.355C93.9623 208.699 93.9982 209.055 94.1331 209.378C94.2679 209.701 94.4956 209.977 94.7874 210.17C95.0791 210.364 95.4217 210.467 95.7718 210.465C96.0038 210.465 96.2335 210.419 96.4477 210.331C96.6619 210.242 96.8565 210.111 97.0202 209.947C97.184 209.783 97.3137 209.587 97.4018 209.373C97.49 209.158 97.535 208.928 97.5341 208.697Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3032 211.52H44.5991V222.814H63.3032V211.52Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M63.303 211.52H53.0698V222.814H63.303V211.52Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_930_54521",
    x1: 4.42432,
    y1: 44.2949,
    x2: 199.704,
    y2: 297.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_930_54521",
    x1: 76.3389,
    y1: 27.5801,
    x2: 227.111,
    y2: 128.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_930_54521",
    x1: 146.133,
    y1: 233.705,
    x2: 156.265,
    y2: 253.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIlustration);
export default __webpack_public_path__ + "static/media/empty-ilustration.a77db30b36df6884aac539f21f015619.svg";
export { ForwardRef as ReactComponent };